import type { RouteRecordRaw } from 'vue-router';
import md from '@/router/middlewares';
import roles from '@/constants/roles';

const vue3Laboratory: RouteRecordRaw = {
    path: '/laboratory',
    name: 'laboratory',
    component: () => import('@/views/laboratory/LaboratoryMain.vue'),
    redirect: { name: 'analysis-requests' },
    meta: {
        middlewares: [md.auth, md.accessControl, md.isNotOperator],
    },
    children: [
        {
            meta: {
                title: 'laboratory.analysisRequests',
                img: 'Analysis.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.SERVICE_TECHNICIAN.value,
                    roles.LABORATORY_MANAGER.value,
                    roles.LABORATORY_TECHNICIAN.value,
                    roles.LABORATORY_CHEMIST.value,
                    roles.SALES_MANAGER.value,
                    roles.SALES_REPRESENTATIVE.value,
                ],
            },
            path: 'analysis-requests',
            name: 'analysis-requests',
            component: () => import('@/views/analysisRequests/AnalysisRequests.vue'),
        },
        {
            meta: {
                title: 'laboratory.workOrders',
                img: 'WorkOrder.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.LABORATORY_MANAGER.value,
                    roles.LABORATORY_TECHNICIAN.value,
                    roles.LABORATORY_CHEMIST.value,
                    roles.SALES_MANAGER.value,
                    roles.SALES_REPRESENTATIVE.value,
                ],
            },
            path: 'work-orders',
            name: 'work-orders',
            component: () => import('@/views/NotImplementedYet.vue'),
        },
        {
            meta: {
                title: 'laboratory.samples',
                img: 'SamplesRegister.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.LABORATORY_MANAGER.value,
                    roles.LABORATORY_TECHNICIAN.value,
                    roles.LABORATORY_CHEMIST.value,
                ],
            },
            path: 'samples',
            name: 'samples',
            component: () => import('@/views/NotImplementedYet.vue'),
        },
        {
            meta: {
                title: 'laboratory.reports',
                img: 'Reports.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.SERVICE_TECHNICIAN.value,
                    roles.LABORATORY_MANAGER.value,
                    roles.LABORATORY_TECHNICIAN.value,
                    roles.LABORATORY_CHEMIST.value,
                    roles.SALES_MANAGER.value,
                    roles.SALES_REPRESENTATIVE.value,
                ],
            },
            path: 'reports',
            name: 'reports',
            component: () => import('@/views/NotImplementedYet.vue'),
        },
        {
            meta: {
                title: 'laboratory.dataTransfer',
                img: 'Move_up_black.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.LABORATORY_MANAGER.value,
                    roles.LABORATORY_TECHNICIAN.value,
                    roles.LABORATORY_CHEMIST.value,
                    roles.SALES_MANAGER.value,
                ],
            },
            path: 'data-transfer',
            name: 'data-transfer',
            component: () => import('@/views/NotImplementedYet.vue'),
        },
        {
            meta: {
                title: 'laboratory.xmlReport',
                img: 'Insert_drive_file_black.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.LABORATORY_MANAGER.value,
                    roles.LABORATORY_TECHNICIAN.value,
                    roles.LABORATORY_CHEMIST.value,
                    roles.SALES_MANAGER.value,
                ],
            },
            path: 'xml-report',
            name: 'xml-report',
            component: () => import('@/views/NotImplementedYet.vue'),
        },
    ],
};

const vue2Laboratory: RouteRecordRaw = {
    path: '/laboratory/:pathMatch(.*)*',
    name: 'laboratory',
    component: { render: () => null },
    beforeEnter: (to) => {
        window.location.replace(`${process.env.VUE_APP_BASE_URL}${to.fullPath}`);
        return false;
    },
};

const laboratory =
    process.env.VUE_APP_ENV_LABEL?.toLowerCase() === 'production' ? vue2Laboratory : vue3Laboratory;
export default laboratory;
